import type { ConversionEventType } from "@enrein/shared-contracts";
import type { StudioRuntimeConfig } from "./env.js";

export async function captureStudioConversionEvent(
  config: StudioRuntimeConfig,
  input: {
    readonly eventType: ConversionEventType;
    readonly pagePath?: string;
    readonly metadata?: Record<string, string | number | boolean>;
  },
): Promise<void> {
  if (!config.apiBaseUrl) {
    return;
  }
  try {
    await fetch(`${config.apiBaseUrl}/v1/public/conversion-events`, {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({
        schemaVersion: "conversion-event-capture.v1.0",
        eventType: input.eventType,
        privacyClass: "AGENCY_OPERATOR",
        retentionClass: "DAYS_90",
        pagePath: input.pagePath ?? "/studio",
        metadata: input.metadata,
      }),
    });
  } catch {
    // Observe-only — never block operator workflow.
  }
}
